import { AfterContentChecked, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
var FuseIfOnDomDirective = /** @class */ (function () {
    function FuseIfOnDomDirective(elementRef, templateRef, viewContainerRef) {
        this.elementRef = elementRef;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.isCreated = false;
    }
    FuseIfOnDomDirective.prototype.ngAfterContentChecked = function () {
        var _this = this;
        if (document.body.contains(this.elementRef.nativeElement) && !this.isCreated) {
            setTimeout(function () {
                _this.viewContainerRef.createEmbeddedView(_this.templateRef);
            }, 300);
            this.isCreated = true;
        }
        else if (this.isCreated && !document.body.contains(this.elementRef.nativeElement)) {
            this.viewContainerRef.clear();
            this.isCreated = false;
        }
    };
    return FuseIfOnDomDirective;
}());
export { FuseIfOnDomDirective };
